import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IMessage, INotificationSplit } from '@app/settings/models';

@Injectable({
  providedIn: 'root'
})
export class CustomNotificationsDOS {
  private _selectedMonthSubject = new BehaviorSubject<Date>(new Date());
  readonly selectedMonth$ = this._selectedMonthSubject.asObservable();

  private _notificationsSubject = new BehaviorSubject<INotificationSplit[]>([]);
  readonly notifications$ = this._notificationsSubject.asObservable();

  private _messagesSubject = new BehaviorSubject<IMessage[]>([]);
  readonly messages$ = this._messagesSubject.asObservable();

  private _restorableSubject = new BehaviorSubject<boolean>(null);
  readonly restorable$ = this._restorableSubject.asObservable();

  private _disableSubmitSubject = new BehaviorSubject<boolean>(null);
  readonly disableSubmit$ = this._disableSubmitSubject.asObservable();

  private _deadlineDateSubject = new BehaviorSubject<string>(null);
  readonly deadlineDate$ = this._deadlineDateSubject.asObservable();

  private _isDataModifiedSubject = new BehaviorSubject<boolean>(false);
  readonly isDataModified$ = this._isDataModifiedSubject.asObservable();

  private _isDataRestoredSubject = new BehaviorSubject<boolean>(false);
  readonly isDataRestored$ = this._isDataRestoredSubject.asObservable();

  updateSelectedMonth(newSelectedMonth: Date): void {
    this._selectedMonthSubject.next(newSelectedMonth);
  }

  getSelectedMonthSnapshot(): Date {
    return this._selectedMonthSubject.value;
  }

  updateNotifications(notifications: INotificationSplit[]): void {
    this._notificationsSubject.next(notifications);
  }

  getNotificationsSnapshot(): INotificationSplit[] {
    return this._notificationsSubject.value;
  }

  updateMessages(messages: IMessage[]): void {
    this._messagesSubject.next(messages);
  }

  getMessagesSnapshot(): IMessage[] {
    return this._messagesSubject.value;
  }

  updateRestorable(newRestorableValue: boolean): void {
    this._restorableSubject.next(newRestorableValue);
  }

  updateDisableSubmit(newChangableValue: boolean): void {
    this._disableSubmitSubject.next(!newChangableValue);
  }

  updateDeadlineDate(deadlineDate: string): void {
    this._deadlineDateSubject.next(deadlineDate);
  }

  updateDataModified(isModified: boolean): void {
    this._isDataModifiedSubject.next(isModified);
  }

  getDataModified(): boolean {
    return this._isDataModifiedSubject.value;
  }

  updateDataRestored(isRestored: boolean): void {
    this._isDataRestoredSubject.next(isRestored);
  }

  getDataRestoredSnapshot(): boolean {
    return this._isDataRestoredSubject.value;
  }
}
